import { Link } from "react-router-dom";
import { ArrowUpRight, Briefcase, Users, ShieldCheck, MapPin } from "lucide-react";

export const RecruitmentPreview = () => {
  const heroImg = "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1400&q=80";

  return (
    <section data-testid="recruitment-preview" className="relative py-24 lg:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-stretch">
          {/* Visual */}
          <div className="lg:col-span-5 relative rounded-2xl overflow-hidden border border-white/10 min-h-[360px]">
            <img src={heroImg} alt="USI Security careers" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-ink-950 via-ink-950/60 to-transparent" />
            <div className="relative p-8 h-full flex flex-col justify-between">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-ink-950/80 backdrop-blur border border-cyan-400/30 w-fit">
                <Briefcase className="w-3.5 h-3.5 text-cyan-400" />
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-300">Now Hiring · Nationwide</span>
              </div>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-400 mb-2">UK Wide</div>
                <h3 className="font-display font-bold text-white text-3xl tracking-tight">Officers · Handlers · Operators</h3>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-cyan-400 mb-4">◆ Careers at USI</p>
            <h2 className="font-display font-extrabold text-white text-3xl lg:text-5xl leading-[1.05] tracking-tighter mb-5">
              Join a team setting the<br />
              <span className="text-gradient-cyan">UK security standard.</span>
            </h2>
            <p className="text-slate-400 leading-relaxed mb-7 max-w-xl">
              We're recruiting SIA-licensed security officers, K9 handlers, control-room operators and field supervisors across the UK. Professional culture, proper training, real career progression.
            </p>

            <div className="grid sm:grid-cols-3 gap-3 mb-8">
              {[
                { icon: ShieldCheck, label: "SIA-Licensed Roles" },
                { icon: Users, label: "Supportive Team" },
                { icon: MapPin, label: "Nationwide Locations" },
              ].map((f) => (
                <div key={f.label} className="flex items-center gap-2.5 p-3 rounded-md bg-white/5 border border-white/10">
                  <f.icon className="w-4 h-4 text-cyan-400 shrink-0" />
                  <span className="text-sm text-slate-200">{f.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3">
              <Link
                to="/recruitment"
                data-testid="recruitment-preview-cta"
                className="group inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-ink-950 font-bold rounded-md px-5 py-3 text-sm transition"
              >
                View careers & apply <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition" />
              </Link>
              <Link
                to="/contact"
                data-testid="recruitment-preview-contact"
                className="inline-flex items-center gap-2 border border-white/20 hover:border-white/40 bg-white/5 text-white font-medium rounded-md px-5 py-3 text-sm transition"
              >
                Contact us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
